module.exports = __webpack_public_path__ + "media/images/pc/stores/yokohama_ekimae/yokohama_ekimae_concept_04-cfc79cfd43a453de4a5cb5775fc5af41.jpg";